import React from "react";

// Simple markdown-like rendering (no external dependency)
const renderContent = (text) => {
  if (!text) return null;

  // Split by code blocks
  const parts = text.split(/(```[\s\S]*?```)/g);
  return parts.map((part, i) => {
    if (part.startsWith("```") && part.endsWith("```")) {
      const code = part.slice(3, -3);
      const firstLine = code.indexOf("\n");
      const lang = firstLine > 0 ? code.slice(0, firstLine).trim() : "";
      const content = firstLine > 0 ? code.slice(firstLine + 1) : code;
      return (
        <pre key={i} style={{
          background: "#1e293b", color: "#e2e8f0", padding: 10, borderRadius: 6,
          fontSize: "0.78rem", overflow: "auto", margin: "6px 0", lineHeight: 1.5,
        }}>
          <code>{content}</code>
        </pre>
      );
    }
    // Inline code
    const inlineParts = part.split(/(`[^`]+`)/g);
    return (
      <span key={i}>
        {inlineParts.map((ip, j) => {
          if (ip.startsWith("`") && ip.endsWith("`")) {
            return <code key={j} style={{
              background: "#f1f5f9", color: "#e11d48", padding: "1px 4px",
              borderRadius: 3, fontSize: "0.78rem",
            }}>{ip.slice(1, -1)}</code>;
          }
          // Bold
          const boldParts = ip.split(/(\*\*[^*]+\*\*)/g);
          return (
            <span key={j}>
              {boldParts.map((bp, k) => {
                if (bp.startsWith("**") && bp.endsWith("**")) {
                  return <strong key={k}>{bp.slice(2, -2)}</strong>;
                }
                return bp;
              })}
            </span>
          );
        })}
      </span>
    );
  });
};

const AIChatMessage = ({ message }) => {
  const isUser = message.role === "user";
  const isStreaming = message.role === "assistant" && message.content === "";

  return (
    <div style={{
      display: "flex", flexDirection: isUser ? "row-reverse" : "row",
      gap: 8, marginBottom: 12, alignItems: "flex-start",
    }}>
      {/* Avatar */}
      <div style={{
        width: 28, height: 28, borderRadius: "50%",
        background: isUser ? "#4f46e5" : "#f1f5f9",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "0.75rem", flexShrink: 0,
        color: isUser ? "#fff" : "#475569",
      }}>
        {isUser ? "U" : "🤖"}
      </div>

      {/* Bubble */}
      <div style={{
        maxWidth: "85%",
        padding: "8px 12px",
        borderRadius: 8,
        background: isUser ? "#eef2ff" : "#fff",
        border: isUser ? "none" : "1px solid #e2e8f0",
        fontSize: "0.82rem",
        lineHeight: 1.6,
        color: "#1e293b",
        wordBreak: "break-word",
      }}>
        {isStreaming ? (
          <span style={{ color: "#94a3b8" }}>Thinking<span className="ai-chat-dots">...</span></span>
        ) : (
          renderContent(message.content)
        )}
      </div>
    </div>
  );
};

export default AIChatMessage;
